import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenCheckIcon, CheckCircle2Icon, LockKeyholeIcon, ScaleIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <header className="border-b border-white/10" data-id="element-81" data-mp="9ka2qpx8ocsp">
      <section className="relative mx-auto max-w-6xl overflow-hidden px-5 pb-12 pt-7 text-center md:px-8 md:pb-16 md:pt-10" data-id="element-82" data-mp="9ipax82b77yj">
        <div className="mx-auto mb-5 flex w-fit items-center gap-2 border border-accent/40 bg-accent/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-accent" data-id="element-83" data-mp="129h0hmovcycw">
          <ScaleIcon size={15} aria-hidden="true" data-id="element-84" data-mp="x8b7dnrar92u" />
          Conversion Elite™
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} data-id="element-85" data-mp="s9gji7eh2ubv">
          <h1 className="mx-auto max-w-4xl font-bold text-white md:text-6xl text-[24px] font-[Poppins,_sans-serif]" data-id="element-86" data-mp="381nrczkpyaz7">
            Todo lo que cambió, en un solo lugar.
          </h1>
          <div className="mx-auto mt-6 max-w-md md:max-w-lg" data-id="element-87" data-mp="3o6kg9kdpcg66">
            <img src="https://cdn.magicpatterns.com/uploads/wFP5MVArJgn3PKWsV6wdEw/ChatGPT_Image_17_jul_2026,_02_43_37_p.m..png" alt="Mockup del Megapack Modernización Laboral 2026" className="w-full drop-shadow-2xl" data-id="element-88" data-mp="39acwgl67hgrf" />
          </div>
        </motion.div>

        <motion.a href="#adquirir" whileHover={{
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="mt-8 inline-flex items-center justify-center gap-2 bg-accent px-7 py-4 text-sm font-extrabold uppercase tracking-wide text-ink shadow-[0_10px_30px_rgba(183,142,69,0.2)] transition-colors hover:bg-[#d2ae6e] focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-ink md:text-base" data-id="element-89" data-mp="358hncui19z33">
          Quiero mi tratado ahora
          <BookOpenCheckIcon size={19} aria-hidden="true" data-id="element-90" data-mp="s2td3kfiu7p7" />
        </motion.a>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-stone-400 md:text-sm" data-id="element-91" data-mp="nb1jf112jluu">
          <span className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="icrpetr2yrat">
            <CheckCircle2Icon size={15} className="text-accent" aria-hidden="true" data-id="element-93" data-mp="ddnfu208urjy" />
            Acceso inmediato
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="161t06nndyej9">
            <LockKeyholeIcon size={15} className="text-accent" aria-hidden="true" data-id="element-95" data-mp="162lzx4nxg3rw" />
            Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-96" data-mp="x0cqki4eagg3">
            <ShieldCheckIcon size={15} className="text-accent" aria-hidden="true" data-id="element-97" data-mp="3lsp3vew9yley" />
            Garantía de 7 días
          </span>
        </div>
      </section>
    </header>;
}